import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { GoogleLogin } from '@react-oauth/google';

export default function Login() {
  const { loginWithGoogle } = useAuth();
  const nav = useNavigate();
  const [err, setErr] = useState<string | null>(null);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4">
      <div className="card w-full max-w-sm p-8 text-center">
        <h1 className="text-2xl font-bold text-brand-700 mb-2">Fiş Takip</h1>
        <p className="text-sm text-slate-500 mb-8">Devam etmek için Google hesabınızla giriş yapın</p>
        
        <div className="flex justify-center mb-4">
          <GoogleLogin
            onSuccess={async (credentialResponse) => {
              try {
                if (credentialResponse.credential) {
                  await loginWithGoogle(credentialResponse.credential);
                  nav('/');
                }
              } catch (e) {
                setErr((e as Error).message);
              }
            }}
            onError={() => {
              setErr('Google girişi başarısız oldu');
            }}
            useOneTap
          />
        </div>
        {err && <div className="text-sm text-red-600 mt-4">{err}</div>}
      </div>
    </div>
  );
}
